// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "safetystandard/css/" + chunkId + "." + "8c00b0c6" + ".css";
};